import { render } from "./ContactView.vue?vue&type=template&id=a85f647e&scoped=true&ts=true"
import script from "./ContactView.vue?vue&type=script&lang=ts"
export * from "./ContactView.vue?vue&type=script&lang=ts"

import "./ContactView.vue?vue&type=style&index=0&id=a85f647e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85f647e"]])

export default __exports__